import { c as _c } from "react-compiler-runtime";
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { useShowSelectQuery } from '../hooks/useShowSelectQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function BulkActionsContainerAboveTable(t0) {
  const $ = _c(6);
  const {
    BulkActionsComponent,
    canSelectAllRecords,
    getRowId,
    isBulkActionsRedesignEnabled,
    isIndexRedesignEnabled,
    rows,
    totalRowCount
  } = t0;
  const {
    showSelectQueryInBulkActionsContainer
  } = useShowSelectQuery(rows, getRowId, canSelectAllRecords, isBulkActionsRedesignEnabled, totalRowCount);
  let t1;
  if ($[0] !== BulkActionsComponent || $[1] !== isBulkActionsRedesignEnabled || $[2] !== isIndexRedesignEnabled || $[3] !== showSelectQueryInBulkActionsContainer || $[4] !== totalRowCount) {
    t1 = /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      paddingBlockEnd: "300",
      showSelectQuery: showSelectQueryInBulkActionsContainer,
      totalRowCount: totalRowCount
    });
    $[0] = BulkActionsComponent;
    $[1] = isBulkActionsRedesignEnabled;
    $[2] = isIndexRedesignEnabled;
    $[3] = showSelectQueryInBulkActionsContainer;
    $[4] = totalRowCount;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}